import React from "react";
import { Container } from "react-bootstrap";
import first from "../../../Asset/ai/card-img-1.png";
import second from "../../../Asset/ai/card-img-2.png";
import third from "../../../Asset/ai/card-img-3.png";
import fourth from "../../../Asset/ai/card-img-4.png";
import fifth from "../../../Asset/ai/card-img-5.png";
import sixth from "../../../Asset/ai/card-img-6.png";

const aiData = [
  {
    img: first,
    title: "Generative AI Solutions",
    description:
      "Our AI experts use advanced machine learning algorithms like GPT-4, GPT-3, Mistral, and Llama to create custom generative AI models tailored to your business needs. We meticulously train and configure these models to deliver high-quality solutions.",
  },
  {
    img: second,
    title: "AI Chatbot Development",
    description:
      "We build intelligent, conversational chatbots and virtual assistants that provide seamless and personalized experiences. Our cutting-edge AI chatbots are designed to revolutionize customer interactions and streamline business processes.",
  },
  {
    img: third,
    title: "Speech AI",
    description:
      "We craft advanced speech AI that understands and responds to human speech. Our solutions range from virtual assistants to real-time transcription, enhancing accessibility and efficiency across diverse applications.",
  },
  {
    img: fourth,
    title: "AI-Powered Surveillance & Facial Recognition Solution",
    description:
      "Our smart surveillance systems offer real-time object detection, facial recognition, and anomaly alerts. These customizable solutions enhance security across diverse environments, from businesses to public spaces.",
  },
  {
    img: fifth,
    title: "Predictive Analytics & Machine Learning",
    description:
      "We convert raw data into actionable insights with custom machine learning models. Our solutions optimize pricing, predict customer churn, forecast inventory, detect fraud, and provide a competitive edge through data-driven decisions.",
  },
  {
    img: sixth,
    title: "Deep Learning Solutions",
    description:
      "We leverage deep learning to solve complex business problems. From image recognition to predictive modeling, we empower you to automate processes, personalize experiences, and extract deeper insights from your data.",
  },
];

const Third = () => {
  return (
    <>
      <section
        className="third-ai-section nineth-d2c-section fifth-logistic-section"
        style={{ backgroundColor: "var(--light-gray-color)" }}
      >
        <Container>
          <div className="text_wrap">
            <h2>
              Advanced <strong>Technologies & Innovation</strong>
            </h2>
            <p className="store-success-intro">
              Utilizing the latest AI technologies and staying ahead of industry
              trends, we bring innovative solutions to drive your business
              forward.
            </p>
          </div>
          <div className="models_cards_warp">
            <div className="row models_row">
              {aiData.map((aiItem, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-6 col-xl-4">
                  <div className="models_boxs">
                    <div className="image_part">
                      <img
                        src={aiItem.img}
                        alt="card-image"
                        className="w-100 h-100 object-fit-cover"
                      />
                    </div>
                    <div className="content_part">
                      <h3>{aiItem.title}</h3>
                      <p>{aiItem.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Third;
